var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { render, screen } from "@testing-library/react";
import FilterSection from "../../../../lib/ReactViews/Workbench/Controls/FilterSection";
import Terria from "../../../../lib/Models/Terria";
import CommonStrata from "../../../../lib/Models/Definition/CommonStrata";
import CreateModel from "../../../../lib/Models/Definition/CreateModel";
import { FilterTraits } from "../../../../lib/Traits/TraitsClasses/Cesium3dTilesTraits";
import objectArrayTrait from "../../../../lib/Traits/Decorators/objectArrayTrait";
import ModelTraits from "../../../../lib/Traits/ModelTraits";
import { runInAction } from "mobx";
import { jsx as _jsx } from "react/jsx-runtime";
let TestTraits = (_dec = objectArrayTrait({
  type: FilterTraits,
  idProperty: "name",
  name: "filters",
  description: "The filters to apply to this catalog item."
}), _class = class TestTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "filters", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "filters", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
class TestModel extends CreateModel(TestTraits) {}
describe("FilterSectionSpec", function () {
  let terria;
  let item;
  beforeAll(() => {
    terria = new Terria({
      baseUrl: "./"
    });
    item = new TestModel("test", terria);
  });
  it("Renders nothing if no filters", function () {
    const {
      container
    } = render(/*#__PURE__*/_jsx(FilterSection, {
      item: item
    }));
    expect(container).toBeEmptyDOMElement();
  });
  it("Renders a range input for each filter", function () {
    runInAction(() => {
      const filter = item.addObject(CommonStrata.user, "filters", "level-filter");
      filter === null || filter === void 0 || filter.setTrait(CommonStrata.user, "property", "level");
      filter === null || filter === void 0 || filter.setTrait(CommonStrata.user, "minimumValue", 0);
      filter === null || filter === void 0 || filter.setTrait(CommonStrata.user, "maximumValue", 42);
      filter === null || filter === void 0 || filter.setTrait(CommonStrata.user, "minimumShown", 10);
      filter === null || filter === void 0 || filter.setTrait(CommonStrata.user, "maximumShown", 20);
    });
    render(/*#__PURE__*/_jsx(FilterSection, {
      item: item
    }));
    expect(screen.getByText("Show level-filter: 10 to 20")).toBeVisible();
    expect(screen.getAllByRole("slider")).toBeDefined();
    expect(screen.getAllByRole("slider").length).toBe(2);
  });
});